<template>
  <div class="avecor-table" style="background:#eee !important"> 
    <!-- TABLE --->
      <!-- <AddContact :companyId="selectedCompanyId" @close="newContactDialog=false" :visible="newContactDialog" ></AddContact>-->
      <!--<v-btn @click.stop="importCompanies" color="#000000" dark class="add-button mb-2">Import</v-btn>-->
      <!--<input type="file" id="fileInput"></input>
      <button @click="importCompanies" id="submit_button">PARSE FILE</button>-->
    
    
    <v-row justify-center style="" class="pt-5">
      <v-col cols="12" class="ma-0 pa-0 text-center">
        <v-btn @click.stop="addContact" color="#000000" dark class="avecor-button-global add-button">
          <!-- <v-icon :size="16">far fa-plus-square</v-icon> -->
          Lisää kontakti
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="getContacts"
      ref="table"
      dense
      :search="search"
      disable-pagination
      hide-default-footer
      :mobile-breakpoint="0"
      fixed-header
      :height="getContacts.length > 6 ? 380 : null"
      class="avecor-ordered-products-table pt-3"
      style="background:#eee"

    >
      <template v-slot:item="props">
        <tr style="height:25px;" class="hide-field-details">
      
          <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
          <td class="justify-center layout px-0">
            <div style="height:33px;padding-top:6px;"
              ><v-icon
                :size="12"
                @click="deleteItem(props.item)"
                v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' || user.uid === 'wcMZF1c4vsMZAmCsXzSDDwh4PJd2'"
                
              >
                far fa-trash-alt
              </v-icon>
            </div>
          </td>
          <!-- <td class="text-xs-left">
            <v-text-field
                v-model="props.item.id"
                @change="inlineSave(props.item)"
                class="avecor-select"
                disabled=""/>
          </td> -->
          <td class="text-xs-left">
            <v-text-field
                v-model="props.item.firstName"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          <td>
            <v-text-field
                v-model="props.item.lastName"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          <td>
            <v-text-field
                v-model="props.item.phone"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          <td>
            <v-text-field
                v-model="props.item.email"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          <td>
            <v-text-field
                v-model="props.item.clientPrintDetailsEmail"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          <td>
            <input style="vertical-align: middle;height:11px;margin-top:3px" type="checkbox" :checked="props.item.sendDraftsToSalesperson" @change=" inlineSaveContact(props.item.id,'sendDraftsToSalesperson', !props.item.sendDraftsToSalesperson)"/>
          </td>
          <td>
            <v-text-field
                v-model="props.item.comments"
                @change="inlineSave(props.item)"
                class="avecor-select mt-0 pt-0"
                hide-details/>
          </td>
          
          <td style="max-width:30px">
            <v-text-field
                slot="input"
                :value="customFormatter(props.item.created_at.seconds * 1000)"
                label="Edit"
                class="avecor-select mt-0 pt-0"
                single-line
                disabled
                hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
export default {
    props: ['companyId'],
    /* 
    <div class="order-expand-header-field-label" style="width:155px;">Lähetä vedos vain myyjälle</div>
                  <input style="vertical-align: middle;height:11px;margin-top:3px" type="checkbox" :checked="contacts[selectedOrder.contactId].sendDraftsToSalesperson" @change="inlineSaveContactDetails('sendDraftsToSalesperson', !contacts[selectedOrder.contactId].sendDraftsToSalesperson)"/> 
    */
    data: () => ({
      dialog: false,
      table: null,
      autogrow: true,
      selected: [],
      search: '',
      headers: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        //{ text: 'Avecor id', value: 'id', align: 'left', sortable: true},
        { text: 'Etunimi', value: 'firstName', align: 'left', sortable: true},
        { text: 'Sukunimi', value: 'lastName', align: 'left', sortable: true},
        { text: 'Puhelinnumero', value: 'phone', align: 'left', sortable: true},
        { text: 'Sähköposti', value: 'email', align: 'left', sortable: true},
        { text: 'Vedoksille sähköposti', value: 'clientPrintDetailsEmail', align: 'left', sortable: true},
        { text: 'Lähetä vedos vain myyjälle', value: 'sendDraftsToSalesperson', align: 'left', sortable: true},
        { text: 'Kommentit', value: 'comments', align: 'left', sortable: true},
        { text: 'Lisätty pvm.', value: 'addedDate', align: 'left', sortable: true},
      ],
      editedIndex: -1,
      latestToCustomerDatePickerMenuMaster : false,
      latestToCustomerDatePickerMenu: [false,false,false,false,false,false,false,false,false,false],
      editedItem: {
        companyId: "",
        firstName: "Tomi",
        lastName: "Hokkanen", 
        phone: '0405440285',
        email: 'tomi.hokkanen@avecor.fi',
        comments: 'tomi.hokkanen@avecor.fi',
        addedDate: null,
      },
      defaultItem: {
        companyId: "",
        firstName: "Tomi",
        lastName: "Hokkanen", 
        phone: '0405440285',
        email: 'tomi.hokkanen@avecor.fi',
        comments: 'tomi.hokkanen@avecor.fi',
        addedDate: null,
      },
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10)
    }),
    mounted() {
      const table = this.$refs.table
      //console.log(this.companyId)
    },
    computed: {
      getContacts(){
        var id = this.companyId
        var contacts = this.contacts
        //var s = []
        var s = Object.keys(this.contacts).reduce(function(result, key) {
          var c = contacts[key]
          if(c.companyId === id) {
            result.push({...c});
          }
          return result;
        }, []);
        
        //console.log(s)
        return s
      },
      ...mapFields([
        "company.companies",
        "contact.contacts",
        "settings",
        "user",
      ]),
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      deleteItem (item) {
        this.$store.dispatch('contact/delete', item.id)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kontakti poistettu.",errorType:"", snackColor:'success',right:true,top:true}))
      },
      addContact() {
        if (this.companyId === ""){
          alert("Yritys idtä ei valittuna")
          return
        }
        var newContact = {
          firstName: "",
          lastName: "", 
          phone: '',
          email: '',
          comments: '',
          companyId:this.companyId
        }
        this.$store.dispatch('contact/set', newContact)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:2000, snackText:"Kontakti lisätty. Syötä tiedot uuteen kontaktiriviin.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      inlineSave (item) {
        let {id, ...y} = item;
        this.$store.dispatch('contact/set', {
          id,
          ...y
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      inlineSaveContact(id,field,value){
        this.$store.dispatch('contact/set', {
          id,
          [field]:value
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/CompanyContactsTable.vue